import { object, array, string, boolean, mixed } from '@/utils/validations';

export default object({
  truck: object({
    typeId: string().required(),
    compositions: array(
      object({
        typeId: string().required(),
        plate: string()
          .matches(/^\w{3}-?\w{4}$/gi, 'Digite uma placa válida')
          .unique('Placas não podem ser iguais')
          .required(),
        renavam: string()
          .when({
            is: (renavam: string) => !renavam.includes('*'),
            then: (schema) => schema.renavam().unique('Renavams não podem ser iguais'),
          })
          .required(),
        chassis: string().chassis().unique('Chassis não podem ser iguais').required(),
        brand: string().required(),
        model: string().required(),
        color: string().required(),
        monofactureYear: string().year().required(),
        modelYear: string().year().required(),
        location: mixed().required(),
        vehicleIsLeased: boolean(),
        leaserCpfCnpj: string().when('vehicleIsLeased', {
          is: true,
          then: (schema) => schema.required(),
          otherwise: (schema) => schema,
        }),
        leaserName: string()
          .when('leaserCpfCnpj', ([leaserCpfCnpj], schema) => (leaserCpfCnpj <= 11 ? schema.name() : schema))
          .when('vehicleIsLeased', {
            is: true,
            then: (schema) => schema.required(),
            otherwise: (schema) => schema,
          }),
        owner: object({
          cpfCnpj: string().cpfOrCnpj().required(),
          name: string()
            .when('cpfCnpj', ([cpfCnpj], schema) => (cpfCnpj.length <= 11 ? schema.name() : schema))
            .required(),
          motherName: string().when('cpfCnpj', ([cpfCnpj], schema) =>
            cpfCnpj.length <= 11 ? schema.required() : schema,
          ),
          birthdate: string().when('cpfCnpj', ([cpfCnpj], schema) =>
            cpfCnpj.length <= 11 ? schema.required() : schema,
          ),
          cellPhone: string().telephoneOrCellPhone().required(),
          rntrc: string().rntrc().required(),
          rntrcCpfCnpj: string()
            .when({ is: (rntrcCpfCnpj: string) => !rntrcCpfCnpj.includes('*'), then: (schema) => schema.cpfOrCnpj() })
            .required(),
          rntrcName: string()
            .when('rntrcCpfCnpj', ([rntrcCpfCnpj], schema) => (rntrcCpfCnpj <= 11 ? schema.name() : schema))
            .required(),
          address: object({
            zipCode: string().zipCode().required(),
            street: string().required(),
            number: string(),
            complement: string(),
            neighborhood: string(),
            location: object().required(),
          }),
        }),
      }),
    ),
  }),
});
